import events$ from '@shared/services/Events'

import { logInfo, logWarning } from '@shared/helpers/Logger'

import { EVENT_CHAT, EVENT_LOGIN, EVENT_URL } from '@shared/config/events'
import { CHANNEL } from '@shared/config/constants'

export default function useUrl() {
  // METHODS
  function sanitizePrefillParams(data) {
    const whitelistKeys = [
      'firstName',
      'gender',
      'dateOfBirth',
      'primeRegion',
      'locationNumber',
      'zipCode',
      'zipCodeAddon',
    ]

    const decodedParams = {}
    const encodedData = data

    atob(encodedData)
      .split(';')
      .filter(i => i.length > 0)
      .forEach(item => {
        const __data = item.split('=')
        if (!whitelistKeys.includes(__data[0])) {
          throw Error('invalid param')
        }

        decodedParams[__data[0]] = decodeURIComponent(__data[1].trim())
      })

    if (whitelistKeys.length !== Object.keys(decodedParams).length) {
      throw Error('invalid param')
    }

    return decodedParams
  }

  function _getChannelByPlatform(platform) {
    switch (platform) {
      /*
      case 'ios':
      case 'android':
        return CHANNEL.PORTAL_APP

      case 'web':
        return CHANNEL.PORTAL_WEB

      */
      case 'ios':
        return 'ios'

      case 'android':
        return 'android'

      case 'web':
        return 'web'

      default:
        return CHANNEL.OVP
    }
  }

  function _openLoginModal() {
    const payload = {
      step: getParamFromUrl('step'),
      platform: getParamFromUrl('platform'),
    }

    // Set correct channel depending on the platform (FLEX-3359)
    payload.channel = getParamFromUrl('source') || _getChannelByPlatform(payload.platform)

    // @note: as we currently don't know, which login-modal we open,
    // we open all the login-modals on a page via the open-all prop
    payload.openAll = true

    window.setTimeout(() => {
      events$.emit(EVENT_LOGIN.OPEN, payload)
    }, 1000)
  }

  function getParamFromUrl(key) {
    return (
      new URLSearchParams(window.location.search).get(key) ||
      new URLSearchParams(window.location.hash?.split('?')?.[1]).get(key)
    )
  }

  function react() {
    const open = getParamFromUrl('open')
    const goto = getParamFromUrl('goto')

    if (open) {
      const components = open.split(',')
      components.forEach(component => {
        switch (component) {
          case 'chat':
            logInfo('OPEN CHAT')
            events$.on(EVENT_CHAT.LOADED, () => {
              events$.emit(EVENT_CHAT.OPEN)
            })
            break

          case 'login': {
            _openLoginModal()
            break
          }

          case 'prefill':
            // @note: is used in SetupDVPWidget and ScreenPersons
            break

          default:
            logWarning(`useUrl can not open unknown option: ${component}`)
        }
      })
    } else if (goto) {
      events$.emit(EVENT_URL.GOTO, {
        target: goto,
      })
    }
  }

  return {
    getParamFromUrl,
    react,
    sanitizePrefillParams,
  }
}
